import { INoRowsOverlayComp } from 'ag-grid-enterprise';

export type NoRowsOverlayProps = {
  emptyImg?: string;
  noRowTitle: string;
  noRowDescription: string;
};

const NoRowsOverlay = (
  props: INoRowsOverlayComp<any, any> & NoRowsOverlayProps
) => {
  return (
    <div
      className="flex flex-col items-center justify-center max-w-[220px]"
      style={{
        left: 'calc(50% - 110px)',
        top: '70px',
      }}
    >
      {props.emptyImg && <img src={props.emptyImg} alt="empty" />}
      <p
        style={{ paddingTop: '8px' }}
        className="text-md font-medium text-lg mb-2 text-gray-300"
      >
        {props.noRowTitle || 'No Data Available'}
      </p>
      <p className="text-foreground">{props.noRowDescription || ''}</p>
    </div>
  );
};

export { NoRowsOverlay };
